import { render, staticRenderFns } from "./CreateStatus.vue?vue&type=template&id=5d339155&scoped=true"
import script from "./CreateStatus.vue?vue&type=script&lang=js"
export * from "./CreateStatus.vue?vue&type=script&lang=js"
import style0 from "./CreateStatus.vue?vue&type=style&index=0&id=5d339155&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d339155",
  null
  
)

export default component.exports